export enum Routes {
    Analysis = "/analysis",
    Monitoring = "/",
    Inventory = "/inventory",
    Alerts = "/alerts",
    Documents = "/documents",
    Login = "/login",
    MultiChannel = "/multiChannel",
    FileRepository = '/repository'
}